import SymbolQuoteCard from './SymbolQuoteCard';

export default SymbolQuoteCard;
